import Bottle from 'bottlejs';

import categoryModel from './categoryModel';

const bottle = new Bottle();
categoryModel(bottle);

const {
  Category,
  categoryAddRecord,
  categoryUpdateRecord,
  categoryRemoveRecords,
  categoryFetchRecord,
  categoryFetchAll,
  recordToID,
  categoryFetchQuery,
} = bottle.container;

export default categoryModel;

export {
  Category,
  categoryAddRecord,
  categoryUpdateRecord,
  categoryRemoveRecords,
  categoryFetchRecord,
  categoryFetchAll,
  recordToID,
  categoryFetchQuery,
};
